import { render } from "./clientsContents.vue?vue&type=template&id=46e488a0&scoped=true"
import script from "./clientsContents.vue?vue&type=script&lang=js"
export * from "./clientsContents.vue?vue&type=script&lang=js"

import "./clientsContents.vue?vue&type=style&index=0&id=46e488a0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e488a0"]])

export default __exports__